export const en = {
    'action-text': 'Yes',
    'cancel-text': 'No'
};
